import axios from "axios";

const BASEURL = process.env.REACT_APP_BASEURL;

const checkResponseStatus = (response) => {
  if (response.status > 399) {
    return response.text().then((text) => {
      throw new Error(text);
    });
  } else {
    return response.data;
  }
};

export async function fetchLogin(data) {
  try {
    const response = await axios.post(BASEURL + "/auth/login", data);
    return checkResponseStatus(response.data);
  } catch (e) {
    if (e) throw new Error(e);
  }
}
